import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { DlpSummary } from "../../components/dlp/DlpSummary";
import { ClientCheckList } from "../../components/Shared/ClientChecklist";
import { IbanNumber } from "../../components/Shared/IbanNumber";
import { Step } from "../../components/stepIndicator/Step";
import { StepIndicator } from "../../components/stepIndicator/StepIndicator";
import { scrollToFirstValidationMessage } from "../../components/validationMessage/scrollToFirstValidationMessage";
import { ValidationMessage } from "../../components/validationMessage/ValidationMessage";
import { useDidMount } from "../../hooks/useDidMount";
import { useDlpFlowContext } from "../../hooks/useDlpContext";
import { FlowLayout } from "../FlowLayout";

interface Props {
  fields: Record<string, Field<string> & { url: string }>;
}

export const DlpFlowStepFive = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { submitOffer, goBack, currentStep, modelState, setModelState, acceptApplication, iban, setters } =
    useDlpFlowContext();

  useDidMount(() => {
    if (currentStep !== 5) {
      goBack(1, props.fields.Step3Path.value);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }

    if (index === 1) {
      goBack(2, props.fields.Step2Path.value);
    }

    if (index === 2) {
      goBack(3, props.fields.Step3Path.value);
    }

    if (index === 3) {
      goBack(4, props.fields.Step4Path.value);
    }
  };

  const submitPaymentDetails = async () => {
    try {
      setLoading(true);
      await submitOffer(props.fields.ThankYouLink.url);
    } catch {
      setLoading(false);
      scrollToFirstValidationMessage();
    }
  };

  if (currentStep !== 5) {
    return null;
  }

  const step5Completed = iban && acceptApplication?.offerIsAccepted;

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={4}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
        <Step label={props.fields.step5Name.value} labelMobile={props.fields.step5MobileName.value} />
      </StepIndicator>
      <FlowLayout
        Sidebar={
          <DlpSummary
            {...props}
            cannotEdit
            submitButtonProps={{
              id: "button_finalize_offer",
              children: props.fields.FinalizeOfferSubmitButtonText.value,
              loading,
              onClick: submitPaymentDetails,
              disabled: !step5Completed,
            }}
          />
        }
        {...props}
      >
        <>
          <ValidationMessage id="global" modelState={modelState} property="Global" />

          <IbanNumber
            fields={props.fields}
            modelState={modelState}
            onUpdateIbanNumber={setters.updateIbanNumber}
            setModelState={setModelState}
            valueIban={iban}
            required
          />
          <ClientCheckList
            fields={props.fields}
            onUpdateAcceptCheckbox={setters.updateAcceptCheckbox}
            offerIsAccepted={acceptApplication?.offerIsAccepted ?? false}
          />
        </>
      </FlowLayout>
    </>
  );
};
